import {
  type EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AuthApi, HttpAuthApi } from './auth.api';
import { AuthService } from './auth.service';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AuthApi, useClass: HttpAuthApi },
    provideAppInitializer(() => firstValueFrom(inject(AuthService).restoreSession())),
  ]);
}
